import React, { useState } from 'react';
import ProtectorList from './protector-list';
import SelectedProtectorList from './selected-protector-list';
import ProtectorCalculations from './protector-calculations';
import OilContractions from './oil-contractions';
import Error from '../../../assets/icons/Error';


const Protector: React.FC = () => {

    const [showError, setShowError] = useState<string[]>(["Protector shaft not suitable for required power"]);

    return (
        <>
            {
                showError?.length > 0 && showError?.map(item => {
                    return (
                        <div className="flex p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-error-500 border-darkcolor-400 mt-1">
                            <Error className="mr-2" />
                            <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
                                {item}
                            </p>
                        </div>
                    )
                })
            }
            <div className='flex flex-col justify-center item-center w-full gap-[16px] mt-4'>
                <ProtectorList showError={showError} setShowError={setShowError} />
                <SelectedProtectorList showError={showError} setShowError={setShowError} />
                <ProtectorCalculations showError={showError} setShowError={setShowError} />
                <OilContractions showError={showError} setShowError={setShowError} />
            </div>
        </>
    );
};

export default Protector;
